import React from 'react'
import settings from 'settings'
import getLocalDateFromUTC from 'app/views/utils/getLocalDateFromUTC'


class UsersDetail extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedUser: null,
    }
  }

  render() {
    const { assessmentDetail } = this.props
    return (
      <table
        className="uk-table uk-table-divider uk-table-small uk-table-middle"
      >
        {assessmentDetail.hacker_stats && (
          <thead>
            <tr>
              <th>User</th>
              <th className="uk-text-center">Completed</th>
              <th className="uk-text-center">
                Score
              </th>
              <th />
            </tr>
          </thead>
        )}
        <tbody className="uk-text-small">
          {!assessmentDetail.hacker_stats && (
            <tr>
              <td
                className="uk-text-center"
                colSpan={4}
              >
                No users have completed this assessment.
              </td>
            </tr>
          )}
          {Boolean(assessmentDetail.hacker_stats) && assessmentDetail.hacker_stats.hackers.map((hacker) => (
            <React.Fragment key={hacker.uuid}>
              <tr className={this.state.selectedUser === hacker.uuid ? 'uk-text-secondary' : ''}>
                <td>{hacker.email}</td>
                <td className="uk-text-center">
                  {`${hacker.completedContent.length} of ${(hacker.incompletedContent.length + hacker.completedContent.length)} completed`}
                </td>
                <td
                  className="uk-text-center"
                >
                  {`${hacker.totalScore || ' - '} / ${hacker.maxScore}`}
                </td>
                <td>
                  <button
                    onClick={() => {
                      const { selectedUser } = this.state
                      this.setState({
                        selectedUser: selectedUser === hacker.uuid ? null : hacker.uuid,
                      })
                    }}
                    className={`uk-button uk-button-small uk-align-right ${this.state.selectedUser === hacker.uuid ? 'uk-button-secondary' : 'uk-button-primary'}`}
                    type="button"
                  >
                    {this.state.selectedUser === hacker.uuid ? 'Close' : 'Details'}
                  </button>
                </td>
              </tr>
              {this.state.selectedUser === hacker.uuid && (
                <tr
                  style={{ borderTop: 'none' }}
                >
                  <td
                    colSpan={4}
                  >
                    <h4>Content Details</h4>
                    <hr />
                  </td>
                </tr>
              )}
              {this.state.selectedUser === hacker.uuid ? [...hacker.completedContent, ...hacker.incompletedContent].map((content, i) => (
                <tr
                  key={`${hacker.uuid}-${content.uuid}`}
                  style={{
                    borderTop: 'none',
                    marginBottom: 30,
                    marginTop: 30,
                    backgroundColor: typeof content.score === 'number' && content.score === 0 ? '#fef4f6' : content.score > 0 ? '#edfbf6' : '#d8eafc4a',
                    borderBottom: i === (hacker.completedContent.length + hacker.incompletedContent.length - 1) ? null : '1px solid #e5e5e5',
                  }}
                >
                  <td>
                    {`${content.title}`}
                    <br />
                    <span
                      className="uk-text-secondary"
                    >
                      {`${settings.engines[content.language.name || content.language]} / ${settings.frameworks[content.framework.name || content.framework]}`}
                      &nbsp;
                      &nbsp;
                      {`(${settings.apps[content.app]})`}
                    </span>
                  </td>
                  <td
                    className="uk-text-center"
                  >
                    {content.completedAt ? `${getLocalDateFromUTC(content.completedAt).format('MMM D, YYYY @ HH:mm')}` : ' - '}
                  </td>
                  <td
                    className="uk-text-center"
                  >
                    {`${typeof content.score === 'number' ? content.score : ' - '} / ${content.maxScore}`}
                  </td>
                  <td
                    className="uk-text-right"
                  >
                    {/* {`${settings.engines[content.language]} / ${settings.frameworks[content.framework]}`} */}
                  </td>
                </tr>
              )) : null}
              {this.state.selectedUser === hacker.uuid && (
                <tr
                  style={{ borderTop: 'none' }}
                >
                  <td
                    colSpan={4}
                  >
                    <div style={{ height: 15 }} />
                  </td>
                </tr>
              )}
            </React.Fragment>
          ))}
        </tbody>
      </table>
    )
  }
}

export default UsersDetail
